/* istanbul ignore next */
import { createUseStyles } from '@glu/theming';

const styles = ({
  breakpoints,
  buttons: {
    fontFamily: buttonFontFamily,
    tertiary: { textColor: buttonTextColor }
  },
  palette: {
    grey,
    text: { light }
  },
  spacing: { unit },
  typography: { fontFamily, fontWeightHeavy, headline3 },
  workflow: {
    extraBox: { amount, subtext },
    footer,
    title
  }
}) => ({
  formContainer: {
    '& [data-component-name="glu-dropdown--dropdown"] label': {
      marginBottom: 0.5 * unit
    },
    '& label': {
      display: 'block'
    }
  },
  footer: {
    marginTop: `${unit * 4}px`,
    paddingLeft: `${unit * 6.25}px !important`,
    [`@media only screen and (max-width: ${breakpoints.values.md}px)`]: {
      paddingLeft: `${unit}px !important`
    }
  },
  footerCell: {
    borderRight: `1px solid ${grey.G700}`,
    display: 'flex',
    flexDirection: 'column',
    marginRight: `${unit * 3.12}px`,
    paddingRight: `${unit * 3.12}px`
  },
  flexWithCenterSpan: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  greyText: {
    color: grey.G600
  },
  addButton: {
    fontFamily: buttonFontFamily,
    color: buttonTextColor,
    border: '0',
    textAlign: 'left'
  },
  hideDropdownArrow: {
    '& > label > button > div > svg': {
      display: 'none'
    }
  },
  currentAmount: {
    fontFamily: headline3.fontFamily,
    fontSize: headline3.fontSize,
    fontWeight: headline3.fontWeight,
    '& span.amount': {
      ...amount
    },
    margin: 'auto',
    '& span.subtext': {
      ...subtext,
      display: 'block'
    }
  },
  middle: {
    // overflowX: 'hidden',
    '& > div': {
      display: 'flex',
      '& .form-group > p': {
        padding: '0'
      },
      flexWrap: 'wrap',
      '& #effectiveEntryDate-toggle': {
        width: '100%'
      },
      margin: '0 -10px',
      '& > *': {
        margin: '0 10px',
        minWidth: '250px'
      },
      padding: '30px 60px'
    },
    '& .container': {
      margin: 0,
      alignItems: 'start',
      display: 'flex',
      width: '100%',
      '& h1': {
        marginRight: '15px'
      }
    }
  },
  footerThemeTextColor: {
    color: footer.color || light
  },
  paymentInformation: {
    marginTop: `${unit * 2}px`,
    padding: `${unit * 3}px`,
    maxWidth: '600px',
    paddingLeft: `${unit * 3}px`,
    '& > article': {
      display: 'flex',
      flexWrap: 'wrap',
      '& > *': {
        minWidth: '300px',
        [`@media only screen and (max-width: ${breakpoints.values.md}px)`]: {
          minWidth: '100%'
        },
        '&.heading': {
          minWidth: '200px'
        }
      }
    },
    boxShadow: '0px 0px 5px 0px rgba(206,206,206,1)'
  },
  entityClass: {
    alignItems: 'center',
    display: 'flex',
    '& label': {
      width: 300
    },
    width: 300
  },
  top: {
    // overflowX: 'hidden',
    '& > div': {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      margin: '0 -10px',
      padding: '60px',
      backgroundColor: grey.G100,
      '& > *': {
        minWidth: '150px',
        margin: '10px'
      }
    }
  },
  entityPopover: {
    marginLeft: 10
  },
  rowLabel: {
    fontFamily,
    fontSize: `${unit * 1.5}px`,
    fontWeight: `${fontWeightHeavy}`,
    textTransform: 'uppercase',
    marginTop: `${unit * 0.5}px`
  },
  entryDatePicker: {
    zIndex: 5
  },
  hidePTag: {
    '&[data-component-name="glu-dropdown--dropdown"].form-group label': {
      marginBottom: 0
    }
  },
  fullWidth: {
    '& > label': {
      width: '100%'
    }
  },
  total: {
    ...title
  },
  masking: {
    alignItems: 'baseline',
    display: 'flex',
    padding: `${unit * 4}px  0 0 ${unit * 7}px `
  },
  payeeInformation: {
    '& h2': {
      minWidth: 'auto'
    },
    '& svg': {
      cursor: 'pointer'
    },
    marginTop: `${unit * 4}px`
  },
  sectionTitle: {
    marginBottom: '60px',
    textTransform: 'uppercase',
    width: '100%'
  },
  widthButton: {
    width: '100%'
  },
  continueButton: {
    marginRight: '10px'
  },
  buttonWithNoSpace: {
    margin: 0,
    padding: 0
  },
  commonButton: {
    marginTop: '18px',
    marginRight: '10px',
    maxHeight: '40px'
  },
  footerFlexRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  paddingTopZero: {
    paddingTop: '0'
  },
  actionAlert: {
    width: '80%',
    maxWidth: '650px',
    margin: '30px 60px'
  },
  challengeManagerContainer: {
    position: 'relative',
    zIndex: '9999'
  },
  bold: {
    fontWeight: fontWeightHeavy
  }
});

export default createUseStyles(styles);
